import React, { useState } from "react";
import styles from "./styles/Partners.module.css";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "./styles/antd.css";
import PartnersDataTable from "./partnersDataTable";
import PaymentsAndRequests from "./paymentsAndRequests";
import Statistics from "./statistics";
import {
  downloadPartnersCSV,
  downloadReferralsCSV,
} from "../../../Utils/adminPartnerUtils";
import SuperCodes from "./superCodes";

function Partners() {
  const [choice, setChoice] = useState(1);
  const [openAddNewPartner, setOpenAddNewPartner] = useState(false);
  const closeAddPartnerModal = () => {
    setOpenAddNewPartner(false);
  };

  return (
    <div className={styles.main_box}>
      <h1 className={styles.main_title}>Partners</h1>
      <div
        className={styles.buttons_container}
        style={choice !== 1 ? { justifyContent: "flex-end" } : {}}
      >
        {choice === 1 && (
          <Button className={styles.buttons_container_left}>
            Export Referral From Individuals
          </Button>
        )}
        <div className={styles.buttons_container_right}>
          {choice !== 3 && (
            <Button
              onClick={(e) => setOpenAddNewPartner(true)}
              className={styles.buttons_container_rightContainer_row1}
            >
              <PlusOutlined />
              Add New Partner
            </Button>
          )}
          {choice === 1 && (
            <div className={styles.buttons_container_rightContainer_row2}>
              <Button
                onClick={() => downloadReferralsCSV()}
                className={styles.buttons_container_rightContainer_row2_button}
              >
                Export Referrals
              </Button>
              <Button
                onClick={() => downloadPartnersCSV()}
                className={styles.buttons_container_rightContainer_row2_button}
              >
                Export Partners
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className={styles.partners_choices}>
        <p
          className={choice === 1 ? styles.partners_choices_active : ""}
          onClick={(e) => setChoice(1)}
        >
          Partners Data
        </p>
        <p
          className={choice === 2 ? styles.partners_choices_active : ""}
          onClick={(e) => setChoice(2)}
        >
          Payments & Requests
        </p>{" "}
        <p
          className={choice === 3 ? styles.partners_choices_active : ""}
          onClick={(e) => setChoice(3)}
        >
          Super Codes
        </p>
        <p
          className={choice === 4 ? styles.partners_choices_active : ""}
          onClick={(e) => setChoice(4)}
        >
          Statistics
        </p>
      </div>
      <div className={styles.table_div}>
        {choice === 1 && (
          <PartnersDataTable
            closeAddPartnerModal={closeAddPartnerModal}
            openAddNewPartner={openAddNewPartner}
            setOpenAddNewPartner={setOpenAddNewPartner}
          />
          // <>
          //   <TableFilter globalSearch={globalSearchFunction} />
          //   <Table
          //     loading={tableLoading}
          //     onRow={(record, rowIndex) => {
          //       return {
          //         onClick: (e) => {
          //           if (e.target.dataset.openpopup === "no") return;
          //           setModalOpened(true);
          //           setPopupData(record);
          //         },
          //       };
          //     }}
          //     rowClassName="td"
          //     columns={columns}
          //     dataSource={filteredData}
          //   ></Table>
          //   <EditPartnerForm
          //     userId={userId}
          //     onOk={closeEditModal}
          //     onCancel={closeEditModal}
          //     open={openEditPartnerModal}
          //     setData={setData}
          //     setFilteredData={setFilteredData}
          //     component={"edit"}
          //   />
          //   <EditPartnerForm
          //     onOk={closeAddPartnerModal}
          //     onCancel={closeAddPartnerModal}
          //     open={openAddNewPartner}
          //     component={"addPartner"}
          //     setData={setData}
          //     setFilteredData={setFilteredData}
          //   />
          //   <PartnerDataPopup
          //     data={popupData}
          //     handleOk={handleOk}
          //     handleCancel={handleCancel}
          //     modalOpened={modalOpened}
          //   />
          // </>
        )}
        {choice === 2 && (
          <PaymentsAndRequests
            closeAddPartnerModal={closeAddPartnerModal}
            openAddNewPartner={openAddNewPartner}
            setOpenAddNewPartner={setOpenAddNewPartner}
          />
        )}
        {choice === 3 && <SuperCodes />}
        {choice === 4 && <Statistics />}
      </div>
    </div>
  );
}

export default Partners;
